import React from "react";
import { Link } from "react-router-dom";
import billingGif from "../assets/dectwin_background.gif";

const Pnf = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f8fafc",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <img
        src={billingGif}
        alt="Page Not Found"
        style={{
          width: "300px",
          maxWidth: "90%",
          marginBottom: "20px",
        }}
      />

      <h1
        style={{
          fontSize: "80px",
          color: "#ff4b2b",
          margin: 0,
          fontWeight: "bold",
        }}
      >
        404
      </h1>

      <h2
        style={{
          marginTop: "10px",
          color: "#334155",
        }}
      >
        Oops! Page Not Found
      </h2>

      <p
        style={{
          color: "#64748b",
          maxWidth: "450px",
        }}
      >
        The page you are looking for doesn't exist or has been moved.
      </p>

      <Link
        to="/login"
        style={{
          marginTop: "20px",
          background: "#ff4b2b",
          color: "#fff",
          padding: "12px 30px",
          borderRadius: "30px",
          textDecoration: "none",
          fontWeight: "600",
        }}
      >
        Back To Login
      </Link>
    </div>
  );
};

export default Pnf;
